document.addEventListener('DOMContentLoaded', () => {
  const searchInputCollections = document.querySelectorAll('.search-input')
  if (searchInputCollections.length === 0) {
    return
  }

  for (let i = 0; i < searchInputCollections.length; i++) {
    const searchInputContainer = searchInputCollections[i]

    const searchInput = searchInputContainer.querySelector('.search-input__input')
    const searchInputButton = searchInput.querySelector('.search-input__close-button')

    searchInput.addEventListener('change', e => {
      if (e.target.value.length > 0) {
        searchInputButton.classList.remove('opacity-0')
      } else {
        searchInputButton.classList.add('opacity-0')
      }
    })


  }
})


